import { makeAutoObservable } from 'mobx'

import type CheckableMap from '@/models/CheckableMap'

import type { CartItem } from './CartItem'

export class CartItemColl {
  constructor(private coll: CheckableMap<CartItem['id'], CartItem>) {
    makeAutoObservable(this)
  }

  get toArr() {
    return this.coll.toArr
  }

  get isPartChecked() {
    return this.coll.isPartChecked
  }

  get toCheckedArr() {
    return this.coll.toCheckedValues
  }

  get checkedCount() {
    return this.coll.checkSize
  }

  get isAllChecked() {
    const activedIds = this.coll.toArr.filter((item) => item.quantity !== 0).map((item) => item.id)

    if (activedIds.length === 0) return false

    return this.coll.isAllCheckedByKeys(activedIds)
  }

  get(id: CartItem['id']) {
    return this.coll.get(id)
  }

  updateOption(
    id: CartItem['id'],
    option: Partial<
      Pick<
        CartItem,
        | 'pdfType'
        | 'printType'
        | 'price'
        | 'additionalPrice'
        | 'students'
        | 'productAmount'
        | 'discountAmount'
      >
    >,
  ) {
    const targetCartItem = this.coll.get(id)

    if (!targetCartItem) return

    targetCartItem.update(option)
  }

  isChecked(id: CartItem['id']) {
    return this.coll.isChecked(id)
  }

  toggleCheck(id: CartItem['id']) {
    this.coll.toggleCheck(id)
  }

  allCheck() {
    this.coll.allCheck()
  }

  toggleAllCheck() {
    this.coll.toggleAllCheck()
  }

  clearAllCheck() {
    this.coll.clearAllCheck()
  }

  delete(id: CartItem['id']) {
    this.coll.delete(id)
  }

  deletes(ids: CartItem['id'][]) {
    this.coll.deletes(ids)
  }
}
